import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {AuthService} from '../../../../shared/auth/auth.service';
import {ToastrService} from 'ngx-toastr';
import {LocalStorageService} from '../../../../shared/storage/local-storage.service';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {


  userData: any;
  submitted = false;
  changepassword = new FormGroup({
    username: new FormControl({value: '', disabled: true}),
    new_password: new FormControl('', [Validators.required]),
    confirm_passwrd: new FormControl('', [Validators.required]),
  });
  showpwd = false;
  showConfirmPassword = false;

  constructor(private authService: AuthService, private toastr: ToastrService, private storage: LocalStorageService) {
  }

  async ngOnInit(): Promise<void> {
    this.storage.getData('script-capture').then(res => {
      if (res != null || res) {
        this.userData = res;
      }
    });
    this.storage.watchStorage().subscribe(res => {
      if (res != null || res) {
        this.userData = res;
      }
    });
    this.authService.fetch_user_detail(this.userData).then((resp: any) => {
      this.changepassword.controls['username'].setValue(resp.email);
    });
  }

  updatePassword() {
    this.submitted = true;
    if (this.changepassword.invalid) {
      return;
    }
    if (this.changepassword.value.new_password !== this.changepassword.value.confirm_passwrd) {
      this.toastr.error('Password mismatch', 'Error', {
        positionClass: 'toast-top-center'
      });
      this.submitted = false;
      return;
    }

    let body = [{
      propName: 'password',
      value: this.changepassword.value.new_password
    }]

    this.authService.update_user_details(this.userData, body).then((res: any) => {
      this.toastr.success('Password changed Successfully', 'Message', {
        positionClass: 'toast-top-center'
      });
      this.submitted = false;
      this.changepassword.controls['new_password'].setValue('');
      this.changepassword.controls['confirm_passwrd'].setValue('');
    }).catch(err => {
      this.toastr.error('Password updation failed', 'Error', {
        positionClass: 'toast-top-center'
      });
    })
  }

  showPassword(password, passwordType) {
    if (passwordType === 'password') {
      this.showpwd = !this.showpwd;
      password.type = this.showpwd ? 'text' : 'password';
    } else {
      this.showConfirmPassword = !this.showConfirmPassword;
      password.type = this.showConfirmPassword ? 'text' : 'password';
    }
  }

}
